<template>
  <div class="diag">
    <div class="row mb-4">
      <div class="col-md-3 mb-4">
        <div class="custom_card_inner">
          <img class="icon" src="/img/icon/icon_errorcode.png" />
          <div class="text_box">
            <div class="title "> 누적 DTC </div>
            <div class="count color1">{{ this.totalCnt }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="custom_card_inner">
          <img class="icon" src="/img/icon/icon_good.png" />
          <div class="text_box">
            <div class="title ">양호</div>
            <!-- <div class="count color2">{{ this.level1Cnt }}</div> -->
            <div class="count color2">{{ this.totalCnt }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="custom_card_inner">
          <img class="icon" src="/img/icon/icon_accident.png" />
          <div class="text_box">
            <div class="title ">입고권장</div>
            <div class="count color3">{{ this.level2Cnt }}</div>
          </div>
        </div>
      </div>
      <div class="col-md-3 mb-4">
        <div class="custom_card_inner">
          <img class="icon" src="/img/icon/icon_emergency.png" />
          <div class="text_box">
            <div class="title ">긴급</div>
            <div class="count color4">{{ this.level3Cnt }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <common-data-table
      hover
      :totalPage="totalPage"
      :curPage="curPage"
      :url="'diag'"
    >
      <template slot="header">
        <b-thead>
          <b-tr>
            <b-th>DTC 에러코드</b-th>
            <b-th>상태</b-th>
            <b-th>내용</b-th>
            <b-th>증상</b-th>
            <b-th>조치</b-th>
          </b-tr>
        </b-thead>
      </template>
      <template slot="body">
        <b-tbody class="custom_tbody">
          <b-tr v-for="(item, index) in items" :key="index">
            <b-td>{{ item.codes }}</b-td>
            <b-td>
              <span class="text-info" v-if="item.level==='1'">양호</span>
              <span class="text-danger" v-if="item.level==='2'">입고 권장</span>
              <span class="text-warning" v-if="item.level==='3'">긴급</span>
            </b-td>
            <b-td>{{ item.content }}</b-td>
            <b-td>{{ item.be }}</b-td>
            <b-td>{{ item.fe }}</b-td>
          </b-tr>
        </b-tbody>
      </template>
    </common-data-table> -->

    <!-- 데이터바우처 -->

    <div id="diag-wrap">
      <div class="diag-card-left">
        <div class="left-item total-diag">
          <div class="left-item-title"> 종합 차량 상태 진단 </div>
          <div class="left-item-content">
            <vc-donut :sections="totalData" :size="200" :thickness="15" unit="px">
              <p class="center_text1 m-0"> 88% </p>
              <!-- p class="center_text2 m-0"><span>{{ lastText(item.pseq) }}</span><span>{{ persentText(item.default_km, item.over_km) }}%</span></p -->
            </vc-donut>
          </div>

        </div>
      </div>
      <div class="diag-card-right">
        <div class="right-item moter-diag">
          <div class="right-item-title"> 모터 진단 </div>
          <div class="right-item-content"></div>

        </div>
        <div class="right-item batt-diag">
          <div class="right-item-title"> 배터리 진단 </div>
          <div class="right-item-content"></div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import ax from '@/api/dtcs'

import Vue from 'vue'
import Donut from 'vue-css-donut-chart'
import 'vue-css-donut-chart/dist/vcdonut.css'
Vue.use(Donut)


export default {
  name: 'CarDiagnosis',
  components: {
    commonDataTable
  },
  data() {
    return {
      curPage: parseInt(this.$route.query.page) || 1,
      totalPage: 1,
      items: [],
      totalCnt: 0,
      level1Cnt: 0,
      level2Cnt: 0,
      level3Cnt: 0,

      totalData:  [{ label: '종합 차량 상태 진단', value: Math.round(88), color: '#F9385F' }]
    }
  },
  watch: {
    '$route.query': function () {
      this.curPage = parseInt(this.$route.query.page) || 1
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      ax.list(this.curPage, this.$route.params.seq, (data) => {
        if (data) {
          this.items = data.data
          this.totalPage = data.totalPage
          this.totalCnt = this.items.length
          this.level1Cnt = _.filter(this.items, { level: '1' }).length
          this.level2Cnt = _.filter(this.items, { level: '2' }).length
          this.level3Cnt = _.filter(this.items, { level: '3' }).length
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card_inner {
  background: #FFFFFF;
  border: 1px solid #F0F0F0;
  box-sizing: border-box;
  border-radius: 8px;
  padding: 12px;
  position: relative;
  height: 85px;

  .icon {
    position: absolute;
    left: 20px;
    top: 20px;
  }

  .text_box {
    position: absolute;
    right: 20px;
    top: 10px;
    text-align: right;

    .title {
      font-size: 14px;
      color: #000;
    }

    .count {
      margin-top: -10px;
      font-weight: 900;
      font-size: 40px;

      &.color1 {
        color: #8E58E5;
      }

      &.color2 {
        color: #007DEF;
      }

      &.color3 {
        color: #FEAB39;
      }

      &.color4 {
        color: #F9385F;
      }
    }
  }
}

.custom_tbody td {
  white-space: normal !important;
}

// 데이터바우처 : 차량진단 카드
#diag-wrap {
  width: 100%;
  height: 470px;

  display: flex;
  flex-direction: row;
  justify-content: left;
}

.diag-card-left {
  width: 50%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .total-diag {
    border: solid 1px #F0F0F0;
    border-radius: 8px;

    width: 95%;
    height: 90%;
  }

  .left-item-title {

    width: 100%;
    height: 10%;
    padding-top: 7px;
    padding-right: 20px;

    text-align: right;
  }

  .left-item-content {
    width: 100%;
    height: 90%;
  }
}

.diag-card-right {
  width: 50%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  .moter-diag {
    border: solid 1px #F0F0F0;
    border-radius: 8px;

    width: 100%;
    height: 40%;
  }

  .batt-diag {
    border: solid 1px #F0F0F0;
    border-radius: 8px;

    width: 100%;
    height: 40%;
  }

  .right-item-title {
    width: 100%;
    height: 15%;
    padding-top: 2px;
    padding-right: 20px;

    text-align: right;
  }

  .right-item-content {
    width: 100%;
    height: 85%;
  }
}
</style>
